import { useState, useEffect } from "react"
import axiosWithAuth from "../../utils/axiosWithAuth"

import "../../styles/ManagerRegister.css"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

function ManagerRemForm() {
  const [ curEmail, setCurEmail ] = useState("")
  const [ emailList, setEmailList ] = useState([])

  useEffect(() => {
    axiosWithAuth().get("/user/admins")
      .then(res => {
        setEmailList(res.data.map(item => { return item.email }))
      })
  }, [])

  const handleEmailChange = e => {
    return setCurEmail(e.target.value)
  }

  const handleRemoveSubmit = e => {
    e.preventDefault()

    axiosWithAuth().delete(`/user/admin/remove/${curEmail}`)
      .then(() => {
        axiosWithAuth().get("/user/admins")
          .then(res => {
            setEmailList(res.data.map(item => { return item.email }))
          })
        setCurEmail("")
        toast("Remove Success")
      })
      .catch(() => {
        toast("Something went wrong")
      })
  }

  return (
    <div className="msu-container">
      <form onSubmit={handleRemoveSubmit} className="msu-form">
        <select className="msu-input" type="dropdown" onChange={handleEmailChange}>
          <option value="">- Select an email -</option>
          {emailList.length > 0 ?
            emailList.map(item => {
              return <option value={item} key={item}>{item}</option>
            })
          : null}
        </select>

        {curEmail ?
          <div className="msu-submit-container">
            <button className="ad-tool" onSubmit={handleRemoveSubmit} >Remove</button>
          </div>
        : null}
      </form>
    </div>
  )
}

export default ManagerRemForm
